var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"looker",staticStyle:{"border":"0","display":"block","margin":"0 auto"},attrs:{"width":"80%","height":"auto","src":"https://lookerstudio.google.com/embed/reporting/c3e88fc4-6bdd-4be4-9ba2-820672ef31ea/page/p_54pyjf8d6c","frameborder":"1","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }